import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";

import appRoutes from "../../routes/appRoutes";

import MakeAPICall from "../../apiCalls/common";

import {
  exportDataApiRoute,
  getRejectedDoctorListApiRoute,
  removeDoctorApplicationApiRoute,
  moveToPendingApiRoute,
  deleteDoctorApiRoute,
  deleteDoctorStripeAccountApiRoute
} from "../../apiRoutes";

import { getFormattedDate, getFormattedTime } from "../../utils/dateTimeHelper";
import { sortData, csUndefined } from "../../utils/commonMethods";

import Button from "../../components/button";
import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";
import CustomModal from "../../components/modal";
import ViewProfilePic from "../../components/viewProfilePic";

import ICNoImg from "../../assets/images/default-picture.png";

const DoctorRejectedPage = props => {
  const csvDownRef = useRef(null);
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [currFilters, setCurrFilters] = useState(
    props.location && props.location.state && props.location.state.currPageNo
      ? {
          skip: props.location.state.currPageNo.skip,
          limit: props.location.state.currPageNo.limit
        }
      : {
          skip: 0,
          limit: 10
        }
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [doctorsList, setDoctorsList] = useState([]);
  const [currSelDoct, setCurrSelDoct] = useState(null);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewProfilePicModal, setShowViewProfilePicModal] = useState(false);
  const [showDelStripeModal, setShowDelStripeModal] = useState(false);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  const tableHeaders = [
    {
      key: "docId",
      value: "UIN"
    },
    {
      key: "profilePic",
      value: "Profile Pic"
    },
    {
      key: "fullName",
      value: "Doctor Details"
    },
    { key: "dateOfBirth", value: "DOB" },
    { key: "gender", value: "Gender" },
    { key: "action", value: "Action" }
  ];

  let excelSheetHeader = [
    { label: "UIN", key: "UIN" },
    {
      label: "Profile Pic",
      key: "Profile_Pic"
    },
    {
      label: "First Name",
      key: "First_Name"
    },
    {
      label: "Middle Name",
      key: "Middle_Name"
    },
    {
      label: "Last Name",
      key: "Last_Name"
    },
    { label: "Gender", key: "Gender" },
    {
      label: "Email Address",
      key: "Email_Address"
    },
    {
      label: "Mobile Number",
      key: "Mobile_Number"
    },
    {
      label: "Unit Number",
      key: "Unit_Number"
    },
    {
      label: "Street Number",
      key: "Street_Number"
    },
    {
      label: "Street Name",
      key: "Street_Name"
    },
    { label: "Suburb", key: "Suburb" },
    { label: "State", key: "State" },
    { label: "Postcode", key: "Postcode" },
    {
      label: "Application Date",
      key: "Application_Date"
    },
    {
      label: "Application Time",
      key: "Application_Time"
    },
    {
      label: "Rejection Date",
      key: "Rejection_Date"
    },
    {
      label: "Rejection Time",
      key: "Rejection_Time"
    },
    {
      label: "Additional Notes from Application",
      key: "Additional_Notes_from_Application"
    },
    {
      label: "Additional Notes Regarding This Doctor",
      key: "Additional_Notes_Regarding_This_Doctor"
    }
  ];

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, doctorsList);
    setDoctorsList(sortedData);
  };

  const showDoctorProfile = id => {
    history.push(appRoutes.doctorRejected + "/" + id, {
      currPageNo: currFilters
    });
  };

  // get doctors list
  const getDoctorsList = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getRejectedDoctorListApiRoute,
      params: currFilters,
      successCallback: async res => {
        let list = [];

        await res.data.data.doctorData.forEach(column => {
          let d = {};

          d._id = column._id;
          d.docId = column.doctorId;
          d.gender = column.gender;
          d.phoneNumber = column.phoneNumber;
          d.accountState = column.accountState;
          d.visibilityMode = column.visibilityMode;
          d.isBlocked = column.isBlocked;
          d.profilePic =
            column.profilePic === null || column.profilePic === undefined
              ? ICNoImg
              : column.profilePic.original;
          d.dateOfBirth = column.dateOfBirth;
          d.email = column.email;
          d.fullName = column.firstName + " ";
          if (
            column.middleName !== null &&
            column.middleName !== undefined &&
            column.middleName !== ""
          ) {
            d.fullName = d.fullName + column.middleName + " ";
          }

          d.fullName = d.fullName + column.lastName;
          if (
            column.manageAccount &&
            column.manageAccount._id &&
            column.stripeDelete
          ) {
            d.stripeDelete = true;
          }
          if (
            column.manageAccount &&
            (column.stripeDelete === undefined || column.stripeDelete === false)
          ) {
            d.stripeDelete = false;
          }

          list.push(d);
        });

        setDoctorsList(list);
        setTotalRecords(res.data.data.totalCount);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // export data
  const exportPatData = e => {
    e.preventDefault();

    setIsProcessing(true);
    var formData = new FormData();
    formData.append("who", "doctor");
    formData.append("rejected", true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: exportDataApiRoute,
      dataObj: formData,
      successCallback: async res => {
        var excelArray = [];
        await res.data.data.forEach(function (column) {
          var e = {};
          e.UIN = column.doctorId;
          e.Profile_Pic = column.profilePic ? column.profilePic.thumb : "";
          e.First_Name = column.firstName;
          e.Middle_Name = column.middleName;
          e.Last_Name = column.lastName;
          e.Gender = column.gender;
          e.Email_Address = column.email;
          e.Mobile_Number = column.phoneNumber;
          e.Unit_Number =
            column.address.unitNumber !== null ? column.address.unitNumber : "";
          e.Street_Number = column.address.streetNumber;
          e.Street_Name = column.address.streetName;
          e.Suburb = column.address.suburb;
          e.State = column.address.state;
          e.Postcode = column.address.postCode;

          e.Application_Date = getFormattedDate(column.createdAt);
          e.Application_Time = getFormattedTime(column.createdAt);
          e.Rejection_Date = getFormattedDate(column.rejectedAt);
          e.Rejection_Time = getFormattedTime(column.rejectedAt);

          if (column.additionalNotesApplication) {
            e.Additional_Notes_from_Application = csUndefined(
              column.additionalNotesApplication
            );
          } else {
            e.Additional_Notes_from_Application = " ";
          }
          if (column.additionalNotesDoctor) {
            e.Additional_Notes_Regarding_This_Doctor = csUndefined(
              column.additionalNotesDoctor
            );
          } else {
            e.Additional_Notes_Regarding_This_Doctor = " ";
          }

          excelArray.push(e);
        });

        setExcelSheetData(excelArray);
        setIsProcessing(false);

        // after setting the excel sheet data trigger the csv download component click event
        csvDownRef.current.link.click();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // delete doctor
  const delSelDoctor = () => {
    setShowDeleteModal(false);
    setIsProcessing(true);

    let parms = {
      doctorId: currSelDoct._id
    };

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: removeDoctorApplicationApiRoute,
      params: parms,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Application Deleted Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // move doctor to new application
  const moveSelDoctor = () => {
    setShowMoveModal(false);
    setIsProcessing(true);

    // var formData = new FormData();
    // formData.append("doctor_id", currSelDoct._id);

    setApiCallParams({
      // reqType: "PUT",
      // reqUrl: moveToPendingApiRoute,
      reqType: "DELETE",
      reqUrl: deleteDoctorApiRoute + currSelDoct._id,
      dataObj: {},
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Doctor Moved Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  // delete selected doctor stripe account
  const delSelDoctorStripeAccount = () => {
    setShowDelStripeModal(false);
    setIsProcessing(true);

    var formData = new FormData();
    formData.append("doctorId", currSelDoct.docId);

    setApiCallParams({
      reqType: "POST",
      reqUrl: deleteDoctorStripeAccountApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Stripe Account Deleted Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getDoctorsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  // restore the previous page state
  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.currPageNo &&
      props.location.state.currPageNo !== null
    ) {
      setCurrFilters({
        skip: props.location.state.currPageNo.skip,
        limit: props.location.state.currPageNo.limit
      });
    }
  }, []);

  const showDocPicModal = doct => {
    setCurrSelDoct(doct);
    setShowViewProfilePicModal(true);
  };

  const showDocDelModal = doct => {
    setCurrSelDoct(doct);
    setShowDeleteModal(true);
  };

  const showMoveToNewModal = doct => {
    setCurrSelDoct(doct);
    setShowMoveModal(true);
  };

  const showDocDelStripeModal = doct => {
    setCurrSelDoct(doct);
    setShowDelStripeModal(true);
  };

  return (
    <div className="view-ticket-container logins-page-container">
      <CustomModal
        openModal={showViewProfilePicModal}
        cancelEvent={() => {
          setShowViewProfilePicModal(false);
          setCurrSelDoct(null);
        }}
        title="View Profile Pic"
        modalBodyContent={
          <ViewProfilePic
            profileImg={currSelDoct !== null ? currSelDoct.profilePic : ICNoImg}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDelStripeModal}
        cancelEvent={() => {
          setShowDelStripeModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={delSelDoctorStripeAccount}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete the Stripe Connected Account for
            <br />
            Dr. {currSelDoct ? currSelDoct.fullName : ""}?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showMoveModal}
        cancelEvent={() => {
          setShowMoveModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={moveSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to move this doctor to <br />
            New Applications?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDeleteModal}
        cancelEvent={() => {
          setShowDeleteModal(false);
          setCurrSelDoct(null);
        }}
        okayEvent={delSelDoctor}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this application?
          </p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelDoct(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          setCurrSelDoct(null);
          getDoctorsList();
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      <div className="d-flex flex-row flex-wrap justify-content-between">
        <h3>Rejected</h3>
        <div className="d-flex flex-row align-items-end">
          <Button clickEvent={exportPatData} title="Export to CSV"></Button>
          <CSVLink
            style={{ display: "none" }}
            ref={csvDownRef}
            className="no-text-decoration"
            filename={"Rejected_Doctor_list.csv"}
            data={excelSheetData}
            headers={excelSheetHeader}
          ></CSVLink>
        </div>
      </div>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {doctorsList.map((doctor, index) => (
            <tr key={index} onClick={() => showDoctorProfile(doctor._id)}>
              <td>{doctor.docId}</td>
              <td
                onClick={e => {
                  e.stopPropagation();
                  showDocPicModal(doctor);
                }}
                className="text-center"
              >
                <img
                  className="rounded-circle user-img"
                  src={doctor.profilePic}
                  alt="user-img"
                />
              </td>
              <td>
                <div className="d-flex flex-column">
                  <p className="mb-0">
                    <b>{doctor.fullName}</b>
                  </p>
                  <a
                    onClick={e => {
                      e.stopPropagation();
                    }}
                    className="high-z-index list-email"
                    href={"mailto:" + doctor.email}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {doctor.email}
                  </a>
                  <p className="mb-0">
                    <ICPhoneDisplay value={doctor.phoneNumber} />
                  </p>
                </div>
              </td>
              <td>{doctor.dateOfBirth}</td>
              <td>{doctor.gender}</td>
              <td>
                <div className="d-flex flex-row align-items-center pt-2">
                  <button
                    style={{
                      width: "fit-content",
                      padding: "0 10px",
                      height: "auto",
                      minHeight: "36px"
                    }}
                    className="ic-btn-transparent"
                    onClick={e => {
                      e.stopPropagation();
                      showMoveToNewModal(doctor);
                    }}
                  >
                    Move to New Applications
                  </button>
                  &nbsp;&nbsp;
                  <button
                    style={{
                      width: "fit-content",
                      padding: "0 10px"
                    }}
                    className="ic-btn-transparent"
                    onClick={e => {
                      e.stopPropagation();
                      showDocDelModal(doctor);
                    }}
                  >
                    Delete
                  </button>
                  &nbsp;&nbsp;
                  {doctor.stripeDelete === false && (
                    <button
                      style={{
                        width: "fit-content",
                        padding: "0 10px"
                      }}
                      className="ic-btn-stripe"
                      onClick={e => {
                        e.stopPropagation();
                        showDocDelStripeModal(doctor);
                      }}
                    >
                      <i
                        className="fab fa-cc-stripe"
                        style={{
                          color: "blue",
                          verticalAlign: "bottom",
                          fontSize: "30px"
                        }}
                      ></i>
                    </button>
                  )}
                  {doctor.stripeDelete === true && (
                    <button
                      style={{
                        width: "fit-content",
                        padding: "0 10px"
                      }}
                      className="ic-btn-stripe"
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <i
                        className="fab fa-cc-stripe"
                        style={{
                          color: "gray",
                          verticalAlign: "bottom",
                          fontSize: "30px"
                        }}
                      ></i>
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </CustomDataTable>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

export default DoctorRejectedPage;
